import {parseISO, sub} from "date-fns";

import {monthWhenVerbose} from "@pg-mono/string-utils";

/**
 * Month and year of the data a FAQ answer talks about.
 *
 * Both parts must come from the SAME date. Taking the year from "now" (as this used to) renders December data
 * as the new year through the whole of January, which breaks the ticket requirement that the stated period
 * matches the presented numbers.
 *
 * `parseISO` keeps "2026-06-01" at local midnight - `new Date(...)` would read it as UTC and slip to May on any
 * host behind UTC, which silently shifts the month.
 *
 * Without a date we fall back to the previous month, because the statistics database is always a month behind.
 */
export const getReportPeriod = (dateString?: string | null): {month: string | undefined; year: number} => {
    const date = dateString ? parseISO(dateString) : sub(new Date(), {months: 1});

    return {
        month: monthWhenVerbose(date.getMonth() + 1),
        year: date.getFullYear()
    };
};
import {parseISO, sub} from "date-fns";

import {monthWhenVerbose} from "@pg-mono/string-utils";

/**
 * Month and year of the data a FAQ answer talks about.
 *
 * Both parts must come from the SAME date. Taking the year from "now" (as this used to) renders December data
 * as the new year through the whole of January, which breaks the ticket requirement that the stated period
 * matches the presented numbers.
 *
 * `parseISO` keeps "2026-06-01" at local midnight - `new Date(...)` would read it as UTC and slip to May on any
 * host behind UTC, which silently shifts the month.
 *
 * Without a date we fall back to the previous month, because the statistics database is always a month behind.
 */
export const getReportPeriod = (dateString?: string | null): {month: string | undefined; year: number} => {
    const date = dateString ? parseISO(dateString) : sub(new Date(), {months: 1});

    return {
        month: monthWhenVerbose(date.getMonth() + 1),
        year: date.getFullYear()
    };
};
